/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      if ( $( '.woocommerce-product-details__short-description' ).length > 0 ) {
        $( '.woocommerce-product-details__short-description' ).addClass( 'wysiwyg' );
      }

      const hash = window.location.hash;

      // If hash is not empty, it means there is a hash element appended to the URL
      if ( hash ) {
        // Do something with the hash
        console.log( 'Hash element found:', hash );
        $( '#ll-register-class' ).click();
        const targetOffset = $( 'form.cart' ).offset().top;

        // Smoothly scroll to the target element's position
        $( 'html, body' ).animate( {
          scrollTop: targetOffset,
        }, 1000 );
      } else {
        // If there is no hash element, do something else
        console.log( 'No hash element found.' );
      }

      function isMobileSize() {
        return $( window ).width() < 768;
      }

      $( 'input#billing_email' ).prop( 'disabled', true );


      $( document ).on( 'click', '.sf-field-taxonomy-product_cat .sf-level-0 > .sf-label-checkbox', function( e ) {
        e.preventDefault();
        const _this = $( this );
        const closestLabel = $( this ).closest( '.sf-label-checkbox' );
        const isOpen = closestLabel.hasClass( 'is-open' );

        $( '.sf-level-0 > .sf-label-checkbox' ).not( closestLabel ).removeClass( 'is-open' ).next( 'ul.children' ).slideUp();

        if ( isOpen ) {
          closestLabel.removeClass( 'is-open' );
          closestLabel.next( 'ul.children' ).slideUp();
        } else {
          closestLabel.addClass( 'is-open' );
          closestLabel.next( 'ul.children' ).slideDown();
        }
      } );

      function openParentCategory() {
        const urlParams = new URLSearchParams( window.location.search );
        const categoryParam = urlParams.get( '_sft_product_cat' );

        if ( categoryParam ) {
          const checkbox = $( 'input[value="' + categoryParam + '"]' );

          if ( checkbox.length > 0 ) {
            const closestLi = checkbox.closest( '.sf-level-1' );

            if ( closestLi.length > 0 ) {
              const parentLi = closestLi.closest( '.sf-level-0' );
              const parentLabel = parentLi.find( '.sf-label-checkbox' );

              parentLabel.addClass( 'is-open' );
              parentLi.children( '.children' ).slideDown();
            }
          }
        }
      }

      openParentCategory();

      $( document ).on( 'sf:ajaxstart', '.searchandfilter', function( e ) {
        if ( !isMobileSize() ) {
          return;
        }
      } );

      $( document ).on( 'sf:ajaxfinish', '.searchandfilter', function( e ) {
        resortDays();
        checkUrlsParams();
        openParentCategory();
      } );

      function checkUrlsParams() {
        const urlParams = new URLSearchParams( window.location.search );
        if ( urlParams.has( 'price' ) ) {
          const priceValue = urlParams.get( 'price' );
          $( 'input[name="wc-donation-price"]' ).val( priceValue );
        }

        if ( urlParams.has( '_sft_ll_class_days' ) ) {
          const dayValue = urlParams.get( '_sft_ll_class_days' );
          const daysArray = dayValue.split( ' ' );
          $( '.sf-field-taxonomy-ll_class_days input[type="checkbox"]' ).each( function() {
            const checkboxValue = $( this ).val();
            if ( daysArray.includes( checkboxValue ) ) {
              $( this ).prop( 'checked', true );
            }
          } );
        }
      }


      $( document ).on( 'click', '.ll-sf-apply-filters', function() {
        $( '.mobile-filter form.searchandfilter' ).submit();
      } );

      $( document ).on( 'click', '.ll-clear-sf-terms', function() {
        const form = $( '.mobile-filter form.searchandfilter' );

        form.find( 'input' ).each( function() {
          const _thisInput = $( this );
          const inputType = _thisInput.attr( 'type' );
          const inputValue = _thisInput.val();

          if ( inputType === 'radio' || inputType === 'checkbox' ) {
            _thisInput.prop( 'checked', false );
          } else {
            _thisInput.val( '' );
          }
        } );
        $( '.ll_clear_sf_term' ).hide();
      } );

      $( document ).on( 'click', '.ll_clear_sf_term', function() {
        const _thisTerm = $( this );
        const form = $( '.mobile-filter form.searchandfilter' );
        const termValue = _thisTerm.data( 'll-sf-value' );

        form.find( 'input' ).each( function() {
          const _thisInput = $( this );
          const inputType = _thisInput.attr( 'type' );
          const inputValue = _thisInput.val();

          if ( inputType === 'radio' || inputType === 'checkbox' ) {
            if ( inputValue === termValue ) {
              _thisInput.prop( 'checked', false );
              _thisTerm.hide();
            }
          } else if ( inputValue === termValue ) {
            _thisInput.val( '' );
            _thisTerm.hide();
          }
        } );
      } );

      $( document ).on( 'click', '.ll-clear-desktop-sf-terms', function() {
        if ( window.location.search.length > 0 ) {
          const params = getUrlParameters();
          reloadPageWithoutParams();
        }
      } );

      function getUrlParameters() {
        const urlParams = new URLSearchParams( window.location.search );
        return urlParams;
      }

      function reloadPageWithoutParams() {
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.href = baseUrl;
      }

      $( document ).on( 'click', '.ll_clear_desktop_sf_term', function() {
        const _thisTerm = $( this );
        const form = $( 'form.searchandfilter' );
        const termValue = _thisTerm.data( 'll-sf-value' );

        form.find( 'input' ).each( function() {
          const _thisInput = $( this );
          const inputType = _thisInput.attr( 'type' );
          const inputValue = _thisInput.val();
          let needsSubmit = false;

          if ( inputType === 'radio' || inputType === 'checkbox' ) {
            if ( inputValue === termValue ) {
              _thisInput.prop( 'checked', false );
              _thisTerm.hide();
              needsSubmit = true;
            }
          } else if ( inputValue === termValue ) {
            _thisInput.val( '' );
            _thisTerm.hide();
            needsSubmit = true;
          }

          if ( needsSubmit ) {
            form.submit();
          }
        } );
      } );

      const registerForClassBtn = $( '#ll-register-class' );
      $( document ).on( 'click', '#ll-register-class', function() {
        $( 'html, body' ).animate( {
          scrollTop: $( 'form.cart.is-open' ).offset().top,
        }, 1000 );
        checkInputs();
      } );

      function checkInputs() {
        let allInputsFilled = true;
        $( 'form.cart input' ).each( function() {
          if ( $( this )[0].offsetParent && $( this ).val() === '' || $( this ).is( '[required]' ) && $( this ).val() === '' ) {
            allInputsFilled = false;
            return false;
          }
        } );

        if ( allInputsFilled ) {
          $( 'form.cart button[type=submit]' ).prop( 'disabled', false );
        } else {
          $( 'form.cart button[type=submit]' ).prop( 'disabled', true );
        }
      }

      if ( registerForClassBtn.length > 0 ) {
        $( 'form.cart input' ).not( 'input[type=hidden]' ).on( 'input', checkInputs );
        checkInputs();
      }

      const $waitlistGravityFormsContainer = $( '#gform_11 .gform_body' );
      $( '#ll-join-waitlist-class' ).on( 'click', function() {
        let doingAjax = false;
        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'get/salesforceId',
          data: {
            id: $( '.ll-product-detail' ).attr( 'data-product-id' ),
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '#input_11_5' ).val( data.salesforce_id );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
          error: function( request, status, error ) {

          },
        } );
      } );

      const basePrice = $( '.amount' ).text();
      const priceNumber = parseFloat( basePrice.replace( '$', '' ) ).toFixed( 2 );
      let rows = 1;
      const $quantityInput = $( 'form.cart .quantity input[type="number"]' );
      const $llQuantityInput = $( '.ll-course-quantity' );
      const maxQuantity = 5;

      const state = new Proxy( {
        quantity: 1,
        actionType: 'input',
      }, {

        set: function( obj, property, newValue ) {
          const oldValue = obj[property];

          if ( property === 'quantity' ) {
            newValue = parseInt( newValue );
            if ( newValue > maxQuantity ) {
              newValue = maxQuantity;
              obj[property] = newValue;
              return true;
            }

            if ( obj.actionType === 'input' ) {
              const add = oldValue < newValue;
              if ( oldValue !== newValue ) {
                if ( ( add && newValue <= maxQuantity ) || !add ) {
                  _this.updateListRows( newValue, add );
                  // $llQuantityInput.attr( 'value', newValue );
                }
              }
            } else if ( obj.actionType === 'list' ) {
              $quantityInput.attr( 'value', newValue );
              $llQuantityInput.attr( 'value', newValue );
            }
          }


          obj[property] = newValue;
          return true;
        },
      } );

      $( '.increase' ).on( 'click', function() {
        const input = $( this ).siblings( 'input[type="number"]' );
        const currentValue = parseInt( input.val() );
        const maxValue = parseInt( input.attr( 'max' ) );

        if ( currentValue < maxValue ) {
          input.val( currentValue + 1 ).trigger( 'change' );
          $quantityInput.val( currentValue + 1 ).trigger( 'input' );
        }
      } );

      $( '.decrease' ).on( 'click', function() {
        const input = $( this ).siblings( 'input[type="number"]' );
        const currentValue = parseInt( input.val() );
        const minValue = parseInt( input.attr( 'min' ) );


        if ( currentValue > minValue ) {
          input.val( currentValue - 1 ).trigger( 'change' );
          $quantityInput.val( currentValue - 1 ).trigger( 'input' );
        }
      } );

      if ( $( '.product.product-type-variable-subscription' ).length === 0 ) {
        $( $quantityInput ).attr( 'max', maxQuantity );
        $( $quantityInput ).on( 'input', function( e ) {
          if ( $( this ).val() > maxQuantity ) {
            $( this ).attr( 'value', maxQuantity );
            return;
          }

          state.actionType = 'input';
          state.quantity = $( this ).val();
          $llQuantityInput.attr( 'value', state.quantity );
        } );

        if ( typeof gform !== 'undefined' ) {
          gform.addAction( 'gform_list_post_item_add', function( item, container ) {
            rows = $( '.gfield_list_group' ).length;
            state.actionType = 'list';
            state.quantity = rows;

            const result = parseFloat( priceNumber * rows ).toFixed( 2 );
            $( '.amount' ).text( '$'+result );
            $( '.ll-course-price' ).text( result );
          } );

          gform.addAction( 'gform_list_post_item_delete', function( item, container ) {
            rows = $( '.gfield_list_group' ).length;
            state.actionType = 'list';
            state.quantity = rows;
            const result = parseFloat( priceNumber * rows ).toFixed( 2 );
            $( '.amount' ).text( '$'+result );
            $( '.ll-course-price' ).text( result );
          } );
        }
      }

      $( document ).on( 'click', '.ll-apply-financial-aid', function( e ) {
        if ( $( this ).hasClass( 'is-apply' ) ) {
          $( this ).removeClass( 'is-apply' );
          $( '.single_add_to_cart_button' ).attr( 'disabled', false );
        } else {
          $( this ).addClass( 'is-apply' );
          $( '.single_add_to_cart_button' ).attr( 'disabled', 'disabled' );
        }
      } );

      const $staffForm = $( '#gform_10' );
      if ( $staffForm.length > 0 ) {
        let doingAjax = false;
        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'get/instructorEmail',
          data: {
            id: $( '.faculty-member__container' ).attr( 'data-faculty-member-id' ),
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '#input_3_6' ).val( data.instructor_email );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
          error: function( request, status, error ) {

          },
        } );
      }

      resortDays();
      checkUrlsParams();

      function resortDays() {
        const daysList = $( '.sf-field-taxonomy-ll_class_days ul' );
        const days = daysList.find( 'li' );

        // Function to convert abbreviated day names to full names
        const getFullDayName = function( abbr ) {
          const daysMap = {
            'mo': 'Monday',
            'tu': 'Tuesday',
            'we': 'Wednesday',
            'th': 'Thursday',
            'fr': 'Friday',
            'sa': 'Saturday',
            'su': 'Sunday',
          };
          return daysMap[abbr.toLowerCase()] || abbr;
        };

        const orderedDays = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

        const uniqueDays = [];
        days.each( function() {
          const dayAbbr = $( this ).find( 'input' ).val();
          if ( !uniqueDays.includes( dayAbbr ) ) {
            uniqueDays.push( dayAbbr );
          }
        } );

        const sortedDays = uniqueDays.sort( function( a, b ) {
          return orderedDays.indexOf( a ) - orderedDays.indexOf( b );
        } );

        daysList.empty();

        sortedDays.forEach( function( dayAbbr ) {
          const fullDayName = getFullDayName( dayAbbr );
          const newDayItem = $( '<li class="sf-level-0">' ).html(
              `<input class="sf-input-checkbox" type="checkbox" value="${dayAbbr}" name="_sft_ll_class_days[]">
              <label data-day="${dayAbbr}" class="ll-sf-label-checkbox" for="_sft_ll_class_days['${dayAbbr}']">${fullDayName}</label>`,
          );
          newDayItem.appendTo( daysList );
        } );

        $( document ).on( 'click', '#place_order', function( e ) {
          $( 'html, body' ).animate( {
            scrollTop: $( 'form.checkout' ).offset().top,
          }, 1000 );
        } );

        $( document ).on( 'click', '.ll-sf-label-checkbox', function( e ) {
          const _this = $( this );
          const day = _this.data( 'day' );
          const checkbox = $( 'input[value="' + day + '"][type="checkbox"]' ); // Find the checkbox with the value
          checkbox.click();
        } );

        $( document ).on( 'change', '.sf-range-max', function( e ) {
          const _this = $( this );

          if ( _this.val() == 21 ) {
            _this.val( _this.val() + '+' );
          }
        } );

        $( document ).ready( function() {
          if ( window.location.hash === '#gform_5' ) {
            $( '#ll-register-class' ).addClass( 'is-open' );
            $( 'form.cart' ).addClass( 'is-open' );
          }
          $( '.products li' ).hover(
              function() {
                $( this ).find( '.shop-archive__image .fit-image' ).css( {
                  'overflow': 'hidden',
                } );
                $( this ).find( '.shop-archive__image img' ).css( {
                  'transform': 'scale(1.1)',
                  'transition': 'transform 0.3s ease-in-out',
                } );

                $( this ).find( '.product-card-title' ).css( {
                  'text-decoration': 'underline',
                } );
              },
              function() {
              // Mouse leave event
                $( this ).find( '.shop-archive__image img' ).css( {
                  'transform': 'scale(1)',
                } );

                $( this ).find( '.product-card-title' ).css( {
                  'text-decoration': 'none',
                } );
              },
          );
        } );
      }
    },
    updateListRows: function( quantity, add = false ) {
      const allAddListItems = $( '.add_list_item' );
      const allDeleteListItems = $( '.delete_list_item' );
      const $llQuantityInput = $( '.ll-quantity-input' );
      if ( add ) {
        $( allAddListItems[allAddListItems.length-1] )?.trigger( 'click' );
        $llQuantityInput.attr( 'value', quantity );
      } else {
        $( allDeleteListItems[allDeleteListItems.length-1] )?.trigger( 'click' );
        $llQuantityInput.attr( 'value', quantity );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll_shop', COMPONENT );
} )( app );
